import { useEffect, useState } from 'react';
import { API_STRING as api } from '@/App';

// Module-level cache so multiple pages share one fetch per load.
let cached = null;
let inflight = null;

export function usePrelaunch(user) {
  const [mode, setMode] = useState(cached);

  useEffect(() => {
    if (cached) return;
    if (!inflight) {
      inflight = fetch(`${api}/launch`)
        .then((r) => r.json())
        .then((d) => {
          cached = d.mode || 'launched';
          return cached;
        })
        .catch(() => {
          cached = 'launched';
          return cached;
        });
    }
    let active = true;
    inflight.then((m) => {
      if (active) setMode(m);
    });
    return () => {
      active = false;
    };
  }, []);

  return {
    loading: mode === null,
    prelaunch: mode === 'prelaunch' && !user?.is_admin,
  };
}

export function clearPrelaunchCache() {
  cached = null;
  inflight = null;
}
